import React, { useState } from 'react';
import axios from 'axios';
const ModalLogin = () => {
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post('/api/v1/login', { ...form })
      .then(({ data }) => {
        if (data.success) {
          window.location.href = '/';
        } else {
          setErrorMessage(true);
        }
      })
      .catch(() => {
        setErrorMessage(true);
      });
  };
  return (
    <div className='modal fade modal-login' id='modal-login'>
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <h5>Đăng nhập</h5>
          <h2>Để tham gia SMEdx ngay.</h2>
          <form
            action=''
            method=''
            onSubmit={(e) => {
              handleLogin(e);
            }}
          >
            <div className='form-group'>
              <label>Email</label>
              <input
                type='text'
                name='email'
                placeholder=''
                required
                onChange={(e) => {
                  handleForm(e.target.value, 'email');
                }}
              />
            </div>
            <div className='form-group'>
              <label>Mật khẩu</label>
              <input
                id='password-field'
                type='password'
                name='password'
                placeholder=''
                required
                onChange={(e) => {
                  handleForm(e.target.value, 'password');
                }}
              />
              <span toggle='#password-field' className='toggle-password'></span>
            </div>
            <p className='text-danger'>
              {errorMessage ? 'Tên tài khoản hoặc mật khẩu sai' : ''}
            </p>
            <button type='submit' className='btn_submit flex-center'>
              Đăng Nhập
            </button>
          </form>
          <div className='flex-between'>
            <label className='remember'>
              <input type='checkbox' />
              Giữ trạng thái đăng nhập
            </label>
            <a
              href='/quen-mat-khau'
              title='Forgot password?'
              className='forgot_pass'
            >
              Quên mật khẩu?
            </a>
          </div>
          <div className='signup'>
            Chưa có tài khoản?{' '}
            <a
              data-dismiss='modal'
              data-toggle='modal'
              data-target='#modal-register'
            >
              Tạo tài khoản
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLogin;
